export const panelWidgets = [
  'cam',
  'weather',
  'partner',
  'calendar',
  'youtube',
  'blog',
  'instagram',
  // 'facts',
  'animal',
];
